import React from 'react';

import { isFieldForListingType } from '../../util/fieldHelpers';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const {
    publicData,
    metadata = {},
    listingFieldConfigs,
    isFieldForCategory,
    intl,
  } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    let { isDetail, label } = showConfig;

    if (key === 'years_of_experience') {
      label = 'Experience';
    }

    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
          ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
          : schemaType === 'long'
            ? filteredConfigs.concat({ key, value, label })
            : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  if (existingListingFields.length === 0) {
    return null;
  }

  // Show the details as a single subtitle line under the title, e.g.
  // "10+ years experience · Female". The experience field reads more naturally
  // with the word "experience" appended.
  const subtitle = existingListingFields
    .filter(detail => detail.value != null && detail.value !== '')
    .map(detail =>
      detail.key === 'years_of_experience'
        ? `${String(detail.value).toLowerCase()} experience`
        : detail.value
    )
    .join(' · ');

  return subtitle ? <p className={css.detailsSubtitle}>{subtitle}</p> : null;
};

export default SectionDetailsMaybe;
